// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"4bbe8102","844":"2f9006dd"}[chunkId] + ".chunk.js";
};